import axios from "../../../services/axios-config.js";

export async function getCommissionedAgents() {
  const res = await axios.get("/commissioned");
  return res?.data || { agents: [], totalDueThisMonth: 0 };
}
